import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SideNavbar from './helpers/SideNavbar';
import { Link } from 'react-router-dom';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto'; // Required for the latest version of chart.js

const ViewPostPerformance = () => {
    const [performanceData, setPerformanceData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const AccessToken = localStorage.getItem("AccessToken");
    const TokenID = localStorage.getItem("Tokenid");
    const AccountType = localStorage.getItem("AccountType");
    const [metricsVisibility, setMetricsVisibility] = useState({
        uniqueImpressions: true,
        shares: true,
        clicks: true,
        likes: true,
        impressions: true,
        comments: true,
    });

    useEffect(() => {
        const fetchPerformanceData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/getpostsperformance`, {
                    params: {
                        TokenID: TokenID,
                        AccessToken: AccessToken,
                        AccountType: AccountType
                    },
                });

                console.log('Full API response:', response.data);
                
                // Check if we have performance data
                if (response.data.elements && response.data.elements.length > 0 && response.data.elements[0].totalShareStatistics) {
                    setPerformanceData(response.data.elements[0].totalShareStatistics);
                } else {
                    // Handle limited permissions case
                    setPerformanceData(null);
                    if (response.data.message) {
                        setError(response.data.message);
                    } else {
                        setError('No performance data available');
                    }
                }
                setLoading(false);
            } catch (err) {
                console.error('Failed to fetch performance data:', err.message);
                setError('Failed to fetch performance data');
                setLoading(false);
            }
        };
        fetchPerformanceData();
    }, [TokenID, AccessToken, AccountType]);

    const toggleMetricVisibility = (metric) => {
        setMetricsVisibility(prevState => ({
            ...prevState,
            [metric]: !prevState[metric],
        }));
    };

    // Make sure filteredData is only initialized after performanceData is available
    const filteredData = performanceData ? {
        labels: [
            metricsVisibility.uniqueImpressions && 'Unique Impressions',
            metricsVisibility.shares && 'Shares',
            metricsVisibility.clicks && 'Clicks',
            metricsVisibility.likes && 'Likes',
            metricsVisibility.impressions && 'Impressions',
            metricsVisibility.comments && 'Comments'
        ].filter(Boolean), // Removes null values
        datasets: [
            {
                label: 'Post Performance',
                data: [
                    metricsVisibility.uniqueImpressions && performanceData.uniqueImpressionsCount || 0,
                    metricsVisibility.shares && performanceData.shareCount || 0,
                    metricsVisibility.clicks && performanceData.clickCount || 0,
                    metricsVisibility.likes && performanceData.likeCount || 0,
                    metricsVisibility.impressions && performanceData.impressionCount || 0,
                    metricsVisibility.comments && performanceData.commentCount || 0,
                ].filter(Boolean), // Removes null values
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                ].slice(0, 6), // Ensure the length matches with the filtered data
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                ].slice(0, 6), // Ensure the length matches with the filtered data
                borderWidth: 1,
            },
        ],
    } : null;

    return (
        <SideNavbar>
            <div className='container'>
                <div className="card shadow-sm p-3" style={{ border: 'none', backgroundColor: '#fff' }}>
                    <div className="card-header" style={{ border: 'none', backgroundColor: '#fff' }}>
                        <Link to="/viewallpendingposts">
                            <h5 className="welcome-text" style={{ fontSize: '20px', color: '#2e3192', textAlign: 'left' }}>
                                <i className="fa fa-arrow-left" style={{ marginRight: '30px' }} aria-hidden="true"></i>
                                View Posts Performance
                            </h5>
                        </Link>
                    </div>
                    <hr />
                    <div className="metrics-controls" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                        <label style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                checked={metricsVisibility.uniqueImpressions}
                                onChange={() => toggleMetricVisibility('uniqueImpressions')}
                                style={{ marginRight: '10px' }}
                            />
                            Unique Impressions
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                checked={metricsVisibility.shares}
                                onChange={() => toggleMetricVisibility('shares')}
                                style={{ marginRight: '10px' }}
                            />
                            Shares
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                checked={metricsVisibility.clicks}
                                onChange={() => toggleMetricVisibility('clicks')}
                                style={{ marginRight: '10px' }}
                            />
                            Clicks
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                checked={metricsVisibility.likes}
                                onChange={() => toggleMetricVisibility('likes')}
                                style={{ marginRight: '10px' }}
                            />
                            Likes
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                checked={metricsVisibility.impressions}
                                onChange={() => toggleMetricVisibility('impressions')}
                                style={{ marginRight: '10px' }}
                            />
                            Impressions
                        </label>
                        <label style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                checked={metricsVisibility.comments}
                                onChange={() => toggleMetricVisibility('comments')}
                                style={{ marginRight: '10px' }}
                            />
                            Comments
                        </label>
                    </div>

                    {loading ? (
                        <div className='spinner'></div>
                    ) : (
                        performanceData ? (
                            <div>
                                <Bar data={filteredData} options={{ responsive: true, maintainAspectRatio: false }} />
                            </div>
                        ) : (
                            <div style={{ padding: '20px', textAlign: 'center' }}>
                                <p style={{ fontSize: '18px', color: '#666', marginBottom: '10px' }}>No performance data available</p>
                                {error && (
                                    <p className='text-danger' style={{ fontSize: '14px', maxWidth: '600px', margin: '0 auto' }}>
                                        {error}
                                    </p>
                                )}
                            </div>
                        )
                    )}
                </div>
            </div>
        </SideNavbar>
    );
};

export default ViewPostPerformance;
